<template>
  <div :class="`formulate-input-element  formulate-input-element--${context.type}`"
    
    :data-type="context.type"
  >
    <div class="notification is-flex is-justify-content-space-between">
      <span class="icon-and-text-wrapper">
        <span class="icon">
          <svg width="32" height="28" viewBox="0 0 32 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.0542 12.9608L20.6409 15.9425C20.6729 16.0513 20.7155 16.1493 20.8115 16.2255L22.3689 17.379L20.0755 17.6293C19.9049 17.6619 19.7662 17.7707 19.6915 17.9122L19.3075 18.8916C19.2329 19.0331 19.2755 19.1745 19.3395 19.316L20.6622 21.6013L18.5075 20.1213L17.6009 15.6269C17.5689 15.4528 17.4302 15.3113 17.2915 15.2787C17.1209 15.246 16.9502 15.2787 16.8435 15.4202L13.7182 19.0766C13.6862 19.1092 13.6862 19.1419 13.6435 19.1854L13.3982 19.6751L11.0409 18.761L12.9822 16.9328C13.1209 16.7913 13.1529 16.5846 13.0889 16.4104L11.4889 12.8955L14.2622 11.1761C14.4009 11.1108 14.4755 10.9693 14.4755 10.8279C14.4755 10.6864 14.4435 10.5449 14.3049 10.447L11.2542 7.78083L11.8409 8.03113C11.9049 8.06377 11.9475 8.06377 12.0115 8.06377C12.1182 8.06377 12.2249 8.03113 12.3209 7.95495L14.3689 6.12673C14.5075 6.01791 14.5395 5.84379 14.5075 5.66968L14.2302 4.47263L15.1369 4.82086C15.1689 4.85351 15.2435 4.85351 15.3075 4.85351H15.4142L16.4169 4.64675L16.2782 5.41939L15.7235 10.0879C15.7235 10.1967 15.7235 10.2946 15.7982 10.3708L16.8435 12.2317C16.9182 12.3731 17.0569 12.4384 17.1849 12.4384H17.2169C17.3555 12.4384 17.4942 12.3731 17.5689 12.2643L19.8622 9.42405L19.6489 11.5679C19.6489 11.7093 19.6809 11.8508 19.7875 11.9487C19.8622 12.014 20.0009 12.0902 20.0969 12.0902H20.1715L20.3422 12.0576L20.0329 12.6887C20.0542 12.754 20.0542 12.8628 20.0542 12.9608ZM5.51553 12.4384L8.19286 13.494C8.22486 13.494 8.29953 13.5267 8.33153 13.5267L10.0702 13.6355H10.1022C10.1662 13.6355 10.2729 13.6028 10.3475 13.5702L10.7635 13.3199L12.1822 16.4431L8.5342 19.8166L5.51553 12.4384ZM18.9769 9.14111L17.3129 11.2087L16.6835 10.0552L17.0675 6.6382L18.9769 9.14111ZM31.4355 9.38052L20.6835 11.0673L20.9609 8.15083L25.1955 2.88383C25.3662 2.67706 25.3342 2.39412 25.1315 2.25266C24.9289 2.07854 24.6515 2.11119 24.5022 2.31795L19.5742 8.39024L17.2169 5.33233L17.8035 0.489733C17.8355 0.250324 17.6649 3.24021e-05 17.4195 3.24021e-05C17.1742 -0.0326143 16.9395 0.141502 16.9395 0.380911L16.5555 3.67823L15.4142 3.92852L14.0595 3.40617L13.4942 1.19708C13.4302 0.946787 13.1849 0.805318 12.9395 0.848847C12.6942 0.91414 12.5555 1.16443 12.5875 1.41472L13.5582 5.52821L11.9262 6.99731L9.13153 5.83291L3.5102 0.957669C3.32887 0.772671 3.01953 0.8162 2.88087 0.990316C2.7102 1.16443 2.7422 1.48002 2.91286 1.62149L13.2915 10.6429L9.96353 12.6778L8.42753 12.6125L0.630199 9.52199C0.384865 9.41317 0.107532 9.55464 0.0328653 9.77228C-0.0738014 10.0226 0.0648653 10.262 0.278199 10.3708L4.33153 11.9814L7.7982 20.4804L0.992865 26.8356C0.822199 27.0098 0.790199 27.2927 0.960865 27.4668C1.06753 27.5756 1.1742 27.6083 1.31287 27.6083C1.41953 27.6083 1.51553 27.5756 1.6222 27.4995L10.3262 19.3813L13.0355 20.4369L9.70753 27.358C9.60087 27.5647 9.70753 27.8477 9.92087 27.9565C9.99553 27.9892 10.0595 27.9892 10.1235 27.9892C10.2942 27.9892 10.4329 27.8803 10.5395 27.7389L14.4969 19.5554L16.9609 16.639L17.7182 20.4369C17.7502 20.5457 17.8249 20.6436 17.8889 20.7198L27.0195 26.9336C27.2329 27.075 27.4995 26.9989 27.6489 26.7921C27.7875 26.5853 27.7129 26.3024 27.5102 26.1609L22.4435 22.7221L20.2889 19.0004L20.5022 18.4781L23.5209 18.1298L24.1075 18.5543C24.1822 18.6304 24.2782 18.6304 24.3849 18.6304C24.5235 18.6304 24.6622 18.5543 24.7689 18.4563C24.9075 18.2495 24.8755 17.9666 24.6622 17.8251L21.5369 15.5399L21.0142 12.9064L21.3555 12.1664L29.4409 15.6378C29.6862 15.7466 29.9209 15.6378 30.0275 15.3875C30.1342 15.1372 30.0275 14.8978 29.7822 14.789L22.4969 11.6658L31.5849 10.262C31.8302 10.2293 32.0009 9.97905 31.9689 9.73964C31.9582 9.48934 31.6809 9.34788 31.4355 9.38052Z" fill="#82B541"/>
          </svg>
        </span>
        <span class="text has-text-weight-bold">
          {{ content.text }}
        </span>
      </span>
    <span class="button is-small has-text-weight-bold is-align-content-end has-text-right">{{ content.label }}</span></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    context: {
      type: Object,
      required: true
    },
    content: {
      type: Object,
      required: true
    },
  },
  data () {
    return {
        
    }
  },
  watch: {
    model () {
    },
  },
  computed: {
    model () {
      return this.context.model
    },
    ...mapGetters({ answers: 'flattenedAnswers'}),
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>
  .notification {
    background:none;
    border:2px solid #82B541;
    padding:1rem 2rem;
    @include mobile() {
      padding:0.5rem 1rem;
    }
  }
  .button {
    background-color:#82B541;
    opacity:1;
    border:none;
    color:#FFF;
    text-transform:uppercase;
    pointer-events: none;

    &:hover {
      color:#FFF;
    }
  }
  span.text, span.icon {
    vertical-align: middle;
    display: inline-block;
  }
  span.icon {
    width:3rem;
  }

  .icon-and-text-wrapper {
    @include mobile() {
      display: flex;
      margin-bottom: 10px;
    }
  }
</style>

<style lang="scss">
  .initio-formulate-component {
    > .formulate-input[data-type=vehiclenoexcessglass] {
      border-top:0;
      padding-top:0;
      .notification {
        @include mobile() {
          flex-wrap: wrap;
        }
      }

    }
  }
</style>